/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Results_PlaceholderInputs */

const en_explorer_search_results_placeholder = /** @type {(inputs: Explorer_Search_Results_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search results will appear here.`)
};

const fr_explorer_search_results_placeholder = /** @type {(inputs: Explorer_Search_Results_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search results will appear here.`)
};

const de_explorer_search_results_placeholder = /** @type {(inputs: Explorer_Search_Results_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search results will appear here.`)
};

const it_explorer_search_results_placeholder = /** @type {(inputs: Explorer_Search_Results_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search results will appear here.`)
};

const ru_explorer_search_results_placeholder = /** @type {(inputs: Explorer_Search_Results_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search results will appear here.`)
};

const es_explorer_search_results_placeholder = /** @type {(inputs: Explorer_Search_Results_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search results will appear here.`)
};

const zh_cn2_explorer_search_results_placeholder = /** @type {(inputs: Explorer_Search_Results_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search results will appear here.`)
};

const ja_explorer_search_results_placeholder = /** @type {(inputs: Explorer_Search_Results_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search results will appear here.`)
};

const hi_explorer_search_results_placeholder = /** @type {(inputs: Explorer_Search_Results_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search results will appear here.`)
};

const pt_pt2_explorer_search_results_placeholder = /** @type {(inputs: Explorer_Search_Results_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search results will appear here.`)
};

/**
* | output |
* | --- |
* | "Search results will appear here." |
*
* @param {Explorer_Search_Results_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_results_placeholder = /** @type {((inputs?: Explorer_Search_Results_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Results_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_search_results_placeholder(inputs)
	if (locale === "de") return de_explorer_search_results_placeholder(inputs)
	if (locale === "it") return it_explorer_search_results_placeholder(inputs)
	if (locale === "ru") return ru_explorer_search_results_placeholder(inputs)
	if (locale === "es") return es_explorer_search_results_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_search_results_placeholder(inputs)
	if (locale === "ja") return ja_explorer_search_results_placeholder(inputs)
	if (locale === "hi") return hi_explorer_search_results_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_search_results_placeholder(inputs)
	return en_explorer_search_results_placeholder(inputs)
});